<div class="row">
    <div class="col-12">
  
        <div class="card">

            <div class="card-header">

                <div class="title">{{ 'IMPORT_AND_EXPORT.IMPORT' | translate }}</div>

                <div class="tools" *ngIf="permissionService.check('ATTRIBUTES_MAPPING_LIST') || permissionService.check('ATTRIBUTES_MAPPING_CREATE')">
                    <button type="button" class="btn btn-primary btn-sm btn-tool" (click)="onCreateTemplate()">
                        <i class="bi bi-files"></i>
                        {{ 'IMPORT_AND_EXPORT.TEMPLATES' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <ul class="list-group">
                    <!-- <li class="list-group-item">
                        <div class="item-content">
                            <div>Загрузка файла с данными ВГХ товаров</div> 
                            <div>
                                <a type="button" class="btn btn-light btn-sm" placement="top" ngbTooltip="Скачать шаблон" href="/assets/templates/product/template_with_wsc_product_data_from_gdc.csv" download="template_with_wsc_product_data_from_gdc.csv">
                                    <i class="bi bi-exclamation-triangle-fill"></i>
                                </a>
                                <button type="button" class="btn btn-primary btn-sm" (click)="fileInputVGH.click()" disabled="{{ fileVGH.data && (fileVGH.inProgress && fileVGH.progress < 100) }}">
                                    <input #fileInputVGH type="file" class="hide" (change)="onSelectedFiles('weight_dimensions_file', $event.target.files)">
                                    <span *ngIf="!fileVGH.inProgress">Загрузить файл</span>
                                    <span *ngIf="fileVGH.inProgress">Загрузка...</span>
                                </button>
                            </div>
                        </div>
                        
                        <div class="item-progressbar" *ngIf="fileVGH.data">
                            <div class="progressbar-active" *ngIf="fileVGH.inProgress && fileVGH.progress < 100">
                                <ngb-progressbar type="primary" [value]="fileVGH.progress"></ngb-progressbar>
                            </div>
                            <div class="progressbar-inactive" *ngIf="!fileVGH.inProgress || fileVGH.progress == 100"></div>
                        </div>

                    </li> -->
                    <li *ngIf="permissionService.check('IMPORT_FILE')" class="list-group-item">
                        <div class="item-content">
                            <div>{{ 'IMPORT_AND_EXPORT.UPLOAD_FILE_W_INFO' | translate }}</div> 
                            <div>
                                <button type="button" class="btn btn-primary btn-sm" (click)="productDataUpload()"> 
                                    <span> {{ 'IMPORT_AND_EXPORT.UPLOAD_FILES' | translate }}</span>
                                </button>
                            </div>
                        </div>
                        
                        <div class="item-progressbar" *ngIf="fileVGH.data">
                            <div class="progressbar-active" *ngIf="fileVGH.inProgress && fileVGH.progress < 100">
                                <ngb-progressbar type="primary" [value]="fileVGH.progress"></ngb-progressbar>
                            </div>
                            <div class="progressbar-inactive" *ngIf="!fileVGH.inProgress || fileVGH.progress == 100"></div>
                        </div>

                    </li>
                    <!-- <li class="list-group-item">

                        <div class="item-content">
                            <div>Загрузка файла с данными этикеток товаров</div>
                            <div>
                                <a type="button" class="btn btn-light btn-sm" placement="top" ngbTooltip="Скачать шаблон" href="/assets/templates/product/template_with_product_label_data.csv" download="template_with_product_label_data.csv">
                                    <i class="bi bi-exclamation-triangle-fill"></i>
                                </a>
                                <button type="button" class="btn btn-primary btn-sm" (click)="fileInputSticker.click()" disabled="{{ fileSticker.data && (fileSticker.inProgress && fileSticker.progress < 100) }}">
                                    <input #fileInputSticker type="file" class="hide" (change)="onSelectedFiles('sticker_data_file', $event.target.files)">
                                    <span *ngIf="!fileSticker.inProgress">Загрузить файл</span>
                                    <span *ngIf="fileSticker.inProgress">Загрузка...</span>
                                </button>
                            </div>
                        </div>

                        <div class="item-progressbar" *ngIf="fileSticker.data">
                            <div class="progressbar-active" *ngIf="fileSticker.inProgress && fileSticker.progress < 100">
                                <ngb-progressbar type="primary" [value]="fileSticker.progress"></ngb-progressbar>
                            </div>
                            <div class="progressbar-inactive" *ngIf="!fileSticker.inProgress || fileSticker.progress == 100"></div>
                        </div>

                    </li> -->
                    <!-- <li class="list-group-item">

                        <div class="item-content">
                            <div>Загрузка файла с данными ВГХ и этикеток товаров</div>
                            <div>
                                <a type="button" class="btn btn-light btn-sm" placement="top" ngbTooltip="Скачать шаблон" href="/assets/templates/product/template_with_wsc_and_sdf.csv" download="template_with_wsc_and_sdf.csv">
                                    <i class="bi bi-exclamation-triangle-fill"></i>
                                </a>
                                
                                <button type="button" class="btn btn-primary btn-sm" (click)="fileInputVGHAndStricker.click()" disabled="{{ fileVGHAndStricker.data && (fileVGHAndStricker.inProgress && fileVGHAndStricker.progress < 100) }}">
                                    <input #fileInputVGHAndStricker type="file" class="hide" (change)="onSelectedFiles('wdf_and_sdf', $event.target.files)">
                                    <span *ngIf="!fileVGHAndStricker.inProgress">Загрузить файл</span>
                                    <span *ngIf="fileVGHAndStricker.inProgress">Загрузка...</span>
                                </button>
                            </div>
                        </div>

                        <div class="item-progressbar" *ngIf="fileSticker.data">
                            <div class="progressbar-active" *ngIf="fileSticker.inProgress && fileSticker.progress < 100">
                                <ngb-progressbar type="primary" [value]="fileSticker.progress"></ngb-progressbar>
                            </div>
                            <div class="progressbar-inactive" *ngIf="!fileSticker.inProgress || fileSticker.progress == 100"></div>
                        </div>

                    </li> -->
                    <!-- <li class="list-group-item">
                        <div class="item-content">
                            <div>{{ 'IMPORT_AND_EXPORT.UPLOAD_ARCHIVE_W_IMG' | translate }}</div>
                            <div class="download-picture">
                                <div class="dropleft notofications-menu instruction-link">
                                    <button type="button" class="btn btn-light btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" placement="top" ngbTooltip="Скачать инструкцию">
                                        <i class="bi bi-exclamation-triangle-fill"></i>
                                    </button>
                                    <div class="dropdown-menu notifications">
                                      <div class="notifications-item">
                                        <div>{{ 'IMPORT_AND_EXPORT.IMG_ONE_ARCHIVE' | translate }}.</div>
                                      </div>
                                      <div class="notifications-item">
                                        <div>{{ 'IMPORT_AND_EXPORT.MORE_RULES' | translate }}</div>
                                      </div>
                                      <a type="button" class="btn btn-light btn-sm" placement="top" ngbTooltip="{{ 'DOWNLOAD_FILE' | translate }}" href="/assets/templates/product/Инструкция_по_подготовке_изображений_для_загрузки_в_систему.docx" download="Инструкция_по_подготовке_изображений_для_загрузки_в_систему.docx">
                                        <i class="bi bi-download"></i> {{ 'DOWNLOAD' | translate }}
                                      </a>
                                    </div>
                                  </div>
                                <ff-button-upload-files label="{{ 'UPLOAD_FILES' | translate }}" [multiple]="btnUploadFilesMultiple"></ff-button-upload-files>
                            </div>
                        </div>
                    </li> -->
                </ul>

            </div>
        </div>

    </div>
</div>
